import type { EntryPoint, EntryPointComponent } from 'react-relay';
import type { OperationType } from 'relay-runtime';
import { JSResourceForUserVisible } from '@atlassian/react-async';
import { createEntryPoint } from '@atlassian/react-entrypoint';

type ServiceDeskCustomerPermissionsEntrypointComponent = EntryPointComponent<
	Record<string, OperationType>,
	// oxlint-disable-next-line @typescript-eslint/no-explicit-any
	Record<string, EntryPoint<any, any> | undefined>,
	{},
	{} | null
>;

export const serviceDeskCustomerPermissionsEntrypoint: EntryPoint<
	ServiceDeskCustomerPermissionsEntrypointComponent,
	{}
> = createEntryPoint({
	root: JSResourceForUserVisible<ServiceDeskCustomerPermissionsEntrypointComponent>(
		/* webpackChunkName: "async-servicedesk-customer-permissions-entrypoint" */ './ServiceDeskCustomerPermissionsPage.tsx',
		{
			entryFsSsrLiftImportToModule: true,
		},
	),
	getPreloadProps: () => ({
		queries: {},
		extraProps: {},
	}),
});
